import Image from "next/image";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import "swiper/css";
import reload from "../../../../../shared-assets/icons/reload.png";
import { HomeDetails } from "../../../../models/home-details";
import { HomeItem, HomeRows } from "../../../../models/home-rows";
import { ProductList } from "../../../../models/product-list";
import AppContext from "../../../../services/app-context-services";
import { _c } from "../../../../services/text-services";
import FetchData from "../../../shared/fetch-data/fetch-data";
import ProductsRowWrapper from "../../../shared/products-row/products-row-wrapper";
import Spinner from "../../../shared/spinner/spinner.component";
import Banner from "../banner/banner";
import CharacterSwiper from "../characters/characters2/characterSwiper";
import Feature from "../feature/feature";
import List from "../list/list";
import AppRecommandedProductsRow from "../recommanded-products-row/recommanded-products-row.component";
import FixedSlider from "../slider/fixedSlider";
import styles from "./home-component.module.scss";
import FunUGC from "../funUGC/funUGC.component";
import PullMessageComponent from "../../../pull-messages/pull-message-component/PullMessageComponent";
import { PullActionType } from "../../../pull-messages/models";

interface AppHomeProps {
  showHeaderOfHome: boolean;
  homeDetailsProp?: HomeRows;
  productListProp?: ProductList;
  isSSR: boolean;
  isTransparentHeader?: boolean;
}

function AppHome({
  homeDetailsProp,
  productListProp,
  showHeaderOfHome,
  isSSR,
  isTransparentHeader
}: AppHomeProps) {
  if (!homeDetailsProp && !productListProp) return null;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const appCtx = useContext(AppContext);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const router = useRouter();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [productList, setProductList] = useState<ProductList | null>(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [homeDetails, setHomeDetails] = useState<HomeRows | HomeDetails | null>(
    null
  );
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [counter, setCounter] = useState(0);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loadMore, setLoadMore] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [homeItems, setHomeItems] = useState<HomeItem[]>([]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    // if the page isSSR, then signal it to the rest of application.
    isSSR && appCtx.setIsSSR(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!router.isReady) return;
    if (
      homeDetailsProp?.data?.home_items &&
      homeDetailsProp.data.home_items.length > 0
    ) {
      setHomeItems(homeDetailsProp.data.home_items);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query, homeDetailsProp]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!!productListProp) {
      setHomeDetails(null);
      setProductList(productListProp);
    } else if (homeDetailsProp) {
      setHomeDetails(homeDetailsProp);
      setProductList(null);
    }
  }, [homeDetailsProp, router.query, productListProp]);
  
  return (
    <>
      <PullMessageComponent
        action_type={PullActionType.HOME_POPUP}
      />

      <div className={_c(styles, "wrapper home_wrapper ")}>
        {homeDetailsProp?.data?.store_message && (
          <div className={_c(styles, "vpn-banner")}>
            <p>
              {homeDetailsProp.data.store_message}
              <Image
                src={reload}
                onClick={() => router.reload()}
                alt="refresh"
                width="25"
                height="25"
                //loader={simpleLoader}
              />
            </p>
          </div>
        )}

        {/* Home items */}
        {!!productList ? (
          <div className={_c(styles, "home-row mt-3 mb-3 i-container")}>
            <div className={_c(styles, "home-item")}>
              <List productList={productList} />
            </div>
          </div>
        ) : (
          homeDetails && (
            <>
              {homeDetails?.next && loadMore && counter > 0 && (
                <FetchData
                  method="GET"
                  url={homeDetails.next}
                  onSuccessful={data => {
                    let newHomeDetails = data as HomeDetails;
                    setHomeDetails(newHomeDetails);
                    setHomeItems(prev => [
                      ...prev,
                      ...newHomeDetails.data.home_items
                    ]);
                    setLoadMore(false);
                  }}
                  counter={counter}
                  unAuthorized={!appCtx.isLoggedIn}
                  hidePending
                  with_dg_id
                />
              )}
              <InfiniteScroll
                dataLength={homeItems.length}
                next={() => {
                  setCounter(c => c + 1);
                  setLoadMore(true);
                }}
                hasMore={!!homeDetails.next}
                loader={<Spinner type="tiny" />}
                style={{ overflow: "visible" }}
              >
                {homeItems.map(item => {
                  if (
                    item.row_mode === 15 &&
                    item?.products &&
                    item.products.length > 0
                  ) {
                    return (
                      <FixedSlider
                        showFixSlider={true}
                        homeItem={item}
                        key={""}
                      />
                    );
                  }
                })}

                <div
                  className={`${
                    isTransparentHeader && styles.withTransparent
                  } ${_c(styles, "mt-3 mb-5 i-container")}`}
                >
                  <div
                    className={`${
                      isTransparentHeader && styles.withTransparent
                    } ${_c(styles, "home-row mt-3 mb-3")}`}
                  >
                    {homeItems.map(item => {
                      switch (item.row_mode) {
                        case 1:
                          return (
                            <div
                              className={_c(styles, "home-item")}
                              key={item.id}
                            >
                              <div className={_c(styles, "section")}>
                                {item?.banner && (
                                  <Banner banner={item.banner} />
                                )}
                              </div>
                            </div>
                          );
                        case 3:
                          return (
                            <div
                              className={_c(styles, "home-item")}
                              key={item.id}
                            >
                              <div className={_c(styles, "section")}>
                                <div className={_c(styles, "")}>
                                  {item?.products &&
                                    item.products.length > 0 && (
                                      <ProductsRowWrapper
                                        products={item.products}
                                        title={item?.title}
                                        size={"half"}
                                        isRelatedFile={false}
                                        activeIndex={1}
                                        series={false}
                                        gaTitle={item?.title}
                                      />
                                    )}

                                  {/* <ProductsRow /> */}
                                </div>
                              </div>
                            </div>
                          );

                        case 4:
                          return (
                            <div
                              className={_c(styles, "home-item")}
                              key={item.id}
                            >
                              <div className={_c(styles, "section")}>
                                <div className={_c(styles, "")}>
                                  {item?.products &&
                                    item.products.length > 0 && (
                                      <Feature
                                        productFeature={item.products[0]}
                                      />
                                    )}
                                  {/* <AppFeatureList /> */}
                                </div>
                              </div>
                            </div>
                          );

                        case 11:
                        case 5:
                        case 10:
                          return (
                            <div
                              className={_c(styles, "home-item")}
                              key={item.id}
                            >
                              <div className={_c(styles, "section")}>
                                <div
                                  className={_c(styles, "recommanded-products")}
                                >
                                  {item?.products &&
                                    item.products.length > 0 && (
                                      <AppRecommandedProductsRow
                                        productsArray={item.products}
                                        title={item.title}
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                          );
                        case 15:
                          return (
                            <>
                              {item?.products && item.products.length > 0 && (
                                <FixedSlider homeItem={item} showSpecialRow />
                              )}
                            </>
                          );

                        case 16:
                          return (
                            <div>
                              {item?.categories &&
                                item.categories.length > 0 && (
                                  <CharacterSwiper homeItem={item} />
                                )}
                            </div>
                          );

                        case 17:
                          return (
                            <div>
                              {item.ugc_list && item.ugc_list.length > 0 && (
                                <FunUGC homeItem={item} />
                              )}
                            </div>
                          );
                      }
                    })}
                  </div>
                </div>
              </InfiniteScroll>
            </>
          )
        )}
      </div>
    </>
  );
}

export default AppHome;
